<div class="bulk-upload-strategy-container">
  <p class="bulk-upload-strategy-header">{{ headerText }}</p>
  <p class="bulk-upload-strategy-body mt-2">
    {{ bodyText }}
  </p>
  <app-radio-selection
    class="bulk-upload-strategy-radio-selection"
    [initialSelectedItemIndex]="Object.values(PDFBoardStrategy).indexOf(selectedStrategy)"
    [selectionItems]="strategiesSelectionItems"
    (itemSelected)="itemSelected($event)"
  >
  </app-radio-selection>

  <mat-accordion
    class="additional-settings-accordion"
    *ngIf="insertingAsSeparateImagesEnabled$ | async"
  >
    <mat-expansion-panel
      class="mat-elevation-z0 additional-settings-panel"
      [expanded]="true"
      hideToggle="true"
      #panel
    >
      <mat-expansion-panel-header class="additional-settings-header-panel">
        <mat-panel-title class="additional-settings-header-title">
          {{ 'ADDITIONAL SETTINGS' | translate }}
        </mat-panel-title>
        <mat-icon class="additional-settings-icon">{{
          panel.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
        }}</mat-icon>
      </mat-expansion-panel-header>

      <div class="additional-settings-content">
        <mat-checkbox
          class="upload-separate-pages-checkbox"
          [(ngModel)]="uploadAsSeparateImages"
          (ngModelChange)="onUploadAsSeparateImagesChange()"
        >
          {{ 'Upload as separate pages' | translate }}
        </mat-checkbox>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
